import { en } from "@/assets/locales/en";
import { fr } from "@/assets/locales/fr";

export const locales = {
    en: en,
    fr: fr
}